import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const organizationModeSchema = z.enum(['create', 'edit'])

export type OrganizationMode = z.infer<typeof organizationModeSchema>

export const organizationSearchParams = z.object({
  mode: organizationModeSchema,
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
})

export const createOrganizationSearch = () => ({
  mode: 'create' as const,
  [SEARCH_PARAM_ORG_ID]: undefined,
  [SEARCH_PARAM_SITE_ID]: undefined,
})

export const editOrganizationSearch = (orgID: string) => ({
  mode: 'edit' as const,
  [SEARCH_PARAM_ORG_ID]: orgID,
  [SEARCH_PARAM_SITE_ID]: undefined,
})
